// extracted by mini-css-extract-plugin
export default {"error":"CompraModal_error__kmImf"};